import { DefaultState } from 'store/types';
import { OccupancyInsightsTableFilters } from 'store/reducers/occupancy-insights/occupancyInsightsTableFilters/types';
import { ReservationOccupancyInsightsEligibleReservationInsights, ReservationsOccupancyInsightsLodgingRequest } from 'store/reducers/occupancy-insights/readReservationOccupancyInsightsData/types';
import { GetLocationMatchesByRequestRow } from 'store/reducers/lodgingOption/get-location-matches-by-request/types';

export const READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_REQUEST = 'READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_REQUEST';
export const READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_SUCCESS = 'READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_SUCCESS';
export const READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_FAILURE = 'READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_FAILURE';

export interface ReservationsOccupancyInsightsParams {
  filters: OccupancyInsightsTableFilters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
};

export interface ReservationOccupancyInsightsRow {
  id: string;
  occupancy: number;
  totalRate: number;
  reservationId: string;
  corporateClientName: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
  providerLabelColor: string;
  fromDate: Date;
  toDate: Date;
  roomType: string;
  lodgingOptionName: string;
  lodgingOptionAddress: string;
  percentageBooked: number;
  costPerson: string;
  bookingId: string | null;
  bookingUserFriendlyId: string | null;
  pricePerDayPerBed: number;
  roomLodgingRequests: ReservationsOccupancyInsightsLodgingRequest[];
  roomLodgingOption: GetLocationMatchesByRequestRow & { _id: string };
  eligibleReservationInsights: ReservationOccupancyInsightsEligibleReservationInsights[];
  reservationInsightsCount: number;
}

export interface ReservationsOccupancyInsightsData {
  rows: ReservationOccupancyInsightsRow[];
  totalCount: number;
};

export type ReadReservationsOccupancyInsightsState = DefaultState & {
  contents?: ReservationsOccupancyInsightsData;
};

interface ReadReservationOccupancyInsightsDataRequest {
  type: typeof READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_REQUEST;
};

interface ReadReservationOccupancyInsightsDataSuccess {
  type: typeof READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_SUCCESS,
  contents: ReservationsOccupancyInsightsData;
}

interface ReadReservationOccupancyInsightsDataFailure {
  type: typeof READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_FAILURE;
}

export type ReservationOccupancyInsightsActionTypes = ReadReservationOccupancyInsightsDataRequest | ReadReservationOccupancyInsightsDataSuccess | ReadReservationOccupancyInsightsDataFailure;